import React from 'react'
import Form from 'react-bootstrap/esm/Form'

export default function BlockTypeOpenQuestion({ blockType, blockContent, setBlockContent, lastError, handleSetBlockContent }) {
	return (
		<>
			{blockType === 'openquestion' && (
				<Form.Group className="mb-3">
					<Form.Label>Pregunta</Form.Label>
					<Form.Control
						type="text"
						onChange={(e) => {
							handleSetBlockContent({ text: e.target.value })
						}}
						value={blockContent.text}
						className={lastError === 'blockContent' && 'with-error'}
					/>
				</Form.Group>
			)}
		</>
	)
}
